import { useState, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import * as S from './PublishedApp.styled';
import GoogleGray from 'assets/images/GoogleGray.svg';
import PropTypes from 'prop-types';
import { ParagraphWithTooltip } from 'components';

const Content = ({
  store_description,
  store_image,
  store_title,
  category,
  store_content_rating,
  store_package,
}) => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const lengthToShow = isOpen ? store_description.length : 80;

  const dots = useCallback(() => {
    return store_description.length > 80 ? (
      <S.ShowMoreLink onClick={() => setIsOpen(!isOpen)} isOpen={isOpen}>
        {!isOpen ? 'Show more' : 'Show less'}
      </S.ShowMoreLink>
    ) : (
      ''
    );
  }, [isOpen]);

  return (
    <S.GoogleSelectedApp>
      <S.AppImage>
        <img src={store_image} />
      </S.AppImage>
      <S.AppDetails>
        <S.DetailsHeader>
          <img src={GoogleGray} alt='google play' />
          <S.Desc>{store_title}</S.Desc>
        </S.DetailsHeader>
        <S.DetailsDescription>
          <span>
            {`${store_description.slice(0, lengthToShow)}`}
            {dots()}
          </span>
        </S.DetailsDescription>
        <S.DetailsFooter>
          <S.DetailsPair>
            <S.DetailsKey>{t('campaign.application.category')}</S.DetailsKey>
            <S.DetailsValue width='46px'>
              <ParagraphWithTooltip text={category} />
            </S.DetailsValue>
          </S.DetailsPair>
          <S.DetailsPair>
            <S.DetailsKey>{t('campaign.application.rated_for')}</S.DetailsKey>
            <S.DetailsValue width='35px'>
              <ParagraphWithTooltip text={store_content_rating} />
            </S.DetailsValue>
          </S.DetailsPair>
          <S.DetailsPair>
            <S.DetailsKey>{t('campaign.application.store_id')}</S.DetailsKey>
            <S.DetailsValue width='80px'>
              <ParagraphWithTooltip text={store_package} />
            </S.DetailsValue>
          </S.DetailsPair>
        </S.DetailsFooter>
      </S.AppDetails>
    </S.GoogleSelectedApp>
  );
};

export default Content;

Content.propTypes = {
  store_description: PropTypes.string.isRequired,
  store_image: PropTypes.string.isRequired,
  store_title: PropTypes.string.isRequired,
  category: PropTypes.string.isRequired,
  store_content_rating: PropTypes.string.isRequired,
  store_package: PropTypes.string.isRequired,
};
